import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "allPayment.m" */ "./Loadable"));
